import { computed, isRef } from 'vue'

export const usePasswordValidation = (passwordInput) => {
  const passwordValue = computed(() => 
    isRef(passwordInput) ? passwordInput.value : passwordInput
  )

  const requirements = {
    minLength: computed(() => passwordValue.value.length >= 8),
    hasUppercase: computed(() => /[A-Z]/.test(passwordValue.value)),
    hasNumber: computed(() => /[0-9]/.test(passwordValue.value)),
    hasSpecial: computed(() => /[^a-zA-Z0-9]/.test(passwordValue.value))
  }

  const isValid = computed(() => 
    requirements.minLength.value &&
    requirements.hasUppercase.value &&
    requirements.hasNumber.value &&
    requirements.hasSpecial.value
  )

  return {
    isValid,
    requirements
  }
}
